module.exports = __webpack_public_path__ + "img/paxel.4178fe18.png";